import { css } from '@Root/lib/lit-3form-block';

// Important Note: Dipper and Mabel are twins. They are quite similar but have
// subtle differences. That said, keep in mind that a change made to one
// ** might ** also be needed in the other.

export const styles = [
  css`
    .mabel-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    /* The block sets align-items on the grid, which would collapse the shared
       rule inside its grid area; stretch it so the border-bottom lands at the
       block's bottom. */
    .horizontal-rule {
      align-self: stretch;
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(var(--text-stack-header-gap) - var(--block-row-gap));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .images {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: inherit;
    }

    /* Image titles: pinned to title-small so the 24px desktop h3 default
       doesn't apply (these were 18/24). */
    h3 {
      font-size: var(--fs-title-small);
      line-height: var(--lh-title-small);
      letter-spacing: var(--ls-title-small);
    }

    img {
      max-width: 100%;
    }

    .images {
      display: flex;
      flex-wrap: wrap;
      gap: calc(60rem / var(--default-rem-px-count));
      padding-top: calc(40rem / var(--default-rem-px-count));
    }

    .image-wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;

      /* Card title and CTA share a first baseline. */
      .image-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;

        /* cta-text sets align-self on its own :host; only a rule from out
           here lets it join the baseline group. */
        cta-text {
          align-self: baseline;
        }
      }

      .image {
        width: 100%;
        display: flex;
        align-items: center;
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      .image-description {
        padding: calc(20rem / var(--default-rem-px-count)) 0;
        font-size: var(--fs-caption);
        line-height: var(--lh-caption);
        letter-spacing: var(--ls-caption);
        text-wrap: pretty;
      }
    }

    @media (min-width: 600px) {
      .header {
        padding-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .mabel-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
        align-items: start;
      }

      /* Top-row texts share a first baseline. */
      .header {
        grid-column: 2 / 5;
        grid-row: 2;
        align-self: baseline;
      }

      .description {
        grid-column: 8 / 12;
        grid-row: 2;
        align-self: baseline;
      }

      .desktop-only {
        display: inherit;
      }

      .mobile-only {
        display: none;
      }

      .images {
        grid-column: 2 / 14;
        grid-row: 3;
        gap: calc(2 * var(--between-column-padding))
          var(--between-column-padding);
        display: grid;
        max-width: 100%;
        padding-top: calc(60rem / var(--default-rem-px-count));
      }

      .two-per-row {
        grid-template-columns: repeat(2, [col] var(--column-width));
      }

      .three-per-row {
        grid-template-columns: repeat(3, [col] var(--column-width));
      }

      .image-description {
        max-width: 66.66%;
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
      }
    }
  `,
];
